export default "__VITE_ASSET__Bqy8fh9G__"